import { Product } from '../../@types/wishlist.js';
import { AbstractApi } from './abstract-api.js';

export interface CartFavoritesApiResponse {
  items: Product[];
}

const buildUrl = (endpoint: string, excludeProductIds: string[]): string => {
  if (excludeProductIds.length === 0) {
    return endpoint;
  }
  const separator = endpoint.includes('?') ? '&' : '?';
  return `${endpoint}${separator}excludeProductIds=${encodeURIComponent(excludeProductIds.join(','))}`;
};

export class CartFavoritesApiInstance extends AbstractApi {
  async getItems(endpoint: string, excludeProductIds: string[] = []): Promise<CartFavoritesApiResponse> {
    return this.get<CartFavoritesApiResponse>(buildUrl(endpoint, excludeProductIds), 'Cart favorites');
  }
}

export const cartFavoritesApi = new CartFavoritesApiInstance();
